import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import HeroCarousel from "./components/HeroCarousel";
import CategoryEntries from "./components/CategoryEntries";
import HotSection from "./components/HotSection";
import NewArrivals from "./components/NewArrivals";
import SiteIntro from "./components/SiteIntro";

export default function Home() {
  useDocumentMeta({
    title: "麻豆免费视频 - 高清影视视频在线观看平台",
    description:
      "麻豆免费视频致力于提供丰富的免费视频影视内容，包括电影、电视剧和综艺节目，满足用户在线观看需求，体验流畅观影体验。",
    keywords: "麻豆免费视频,免费视频,影视视频,在线观看,电影,电视剧,综艺节目,高清视频",
    canonicalPath: "/",
  });

  return (
    <>
      <HeroCarousel />
      <CategoryEntries />
      <HotSection type="movie" subtitle="精选高口碑电影，类型丰富任你看" />
      <HotSection type="tv" subtitle="热播剧集连续更新，追剧不掉线" />
      <HotSection type="variety" subtitle="当红综艺一网打尽，轻松解压" />
      <NewArrivals />
      <SiteIntro />
    </>
  );
}